import React from "react"
import styled from "styled-components"

import { Element } from "legacy/components/shared/base"

export interface NavItemProps {
  slug: string
  text: string
}

const StyledElement = styled(Element)`
  &:hover,
  &:focus {
    border-top-color: #2e827c;
  }
`

const NavItem: React.FC<NavItemProps> = ({
  slug,
  text,
}): React.ReactElement | null => {
  return (
    <StyledElement
      as="a"
      borderTopColor="transparent"
      borderTopStyle="solid"
      borderTopWidth="5px"
      color="navy"
      fontFamily="martel"
      href={`#${slug}`}
      pt="20"
      textDecoration="none"
    >
      {text}
    </StyledElement>
  )
}

export default NavItem
